export default __webpack_public_path__ + "static/media/S.c1993637.svg";